import type { RouteRecordRaw } from 'vue-router';

const supportRoutes: RouteRecordRaw[] = [
  {
    path: '/support',
    name: 'support',
    component: () => import('@/domains/support/views/SupportView.vue'),
    meta: { renderer: 'native' },
  },
];

export default supportRoutes;
